
import { db } from '../firebase';
import { 
    collection, 
    query, 
    where, 
    onSnapshot 
} from 'firebase/firestore';
import { Invitation } from '../types';

export const InvitationService = {
    /**
     * Subscribes to pending invitations for a specific user and organization.
     */
    listenToUserInvitations(userId: string, orgId: string, callback: (invs: Invitation[]) => void) {
        const q = query(
            collection(db, 'invitations'),
            where('orgId', '==', orgId),
            where('inviteeId', '==', userId),
            where('status', '==', 'pending')
        );

        return onSnapshot(q, (snapshot) => {
            callback(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Invitation)));
        });
    },

    /**
     * Subscribes to all pending invitations for an organization.
     */
    listenToAllOrgInvitations(orgId: string, callback: (invs: Invitation[]) => void) {
        const q = query(
            collection(db, 'invitations'),
            where('orgId', '==', orgId),
            where('status', '==', 'pending')
        );

        return onSnapshot(q, (snapshot) => {
            callback(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Invitation)));
        });
    },

    /**
     * Subscribes to pending email invitations matching a specific email.
     */
    listenToEmailInvitations(email: string, callback: (invs: Invitation[]) => void) {
        const q = query(
            collection(db, 'emailInvitations'),
            where('email', '==', email.toLowerCase()),
            where('status', '==', 'pending')
        );

        return onSnapshot(q, (snapshot) => {
            callback(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Invitation)));
        });
    }
};
